// action types
import { createRequestTypes } from "../../utils";

// Fetch monitoring records
export const FETCH_MONITORING_RECORDS = createRequestTypes("FETCH_MONITORING_RECORDS");
export const FETCH_MONITORING_SUMMARY = createRequestTypes("FETCH_MONITORING_SUMMARY");
export const FETCH_MONITORING_DETAIL = createRequestTypes("FETCH_MONITORING_DETAIL");

// Create/Update/Delete monitoring record
export const CREATE_MONITORING_RECORD = createRequestTypes("CREATE_MONITORING_RECORD");
export const UPDATE_MONITORING_RECORD = createRequestTypes("UPDATE_MONITORING_RECORD");
export const DELETE_MONITORING_RECORD = createRequestTypes("DELETE_MONITORING_RECORD");

// UI State
export const CLEAR_MONITORING_RECORDS = 'CLEAR_MONITORING_RECORDS';
export const SET_SELECTED_MONITORING_RECORD = 'SET_SELECTED_MONITORING_RECORD';

// ==================== MONITORING RECORDS ====================

export const fetchMonitoringRecordsRequest = (batchId) =>
    ({ type: FETCH_MONITORING_RECORDS.REQUEST, payload: { batchId } });

export const fetchMonitoringRecordsSuccess = (records) =>
    ({ type: FETCH_MONITORING_RECORDS.SUCCESS, payload: records });

export const fetchMonitoringRecordsFailure = (error) =>
    ({ type: FETCH_MONITORING_RECORDS.FAILURE, payload: error });

export const fetchMonitoringSummaryRequest = (batchId) =>
    ({ type: FETCH_MONITORING_SUMMARY.REQUEST, payload: { batchId } });

export const fetchMonitoringSummarySuccess = (summary) =>
    ({ type: FETCH_MONITORING_SUMMARY.SUCCESS, payload: summary });

export const fetchMonitoringSummaryFailure = (error) =>
    ({ type: FETCH_MONITORING_SUMMARY.FAILURE, payload: error });

export const fetchMonitoringDetailRequest = (recordId) =>
    ({ type: FETCH_MONITORING_DETAIL.REQUEST, payload: { recordId } });

export const fetchMonitoringDetailSuccess = (record) =>
    ({ type: FETCH_MONITORING_DETAIL.SUCCESS, payload: record });

export const fetchMonitoringDetailFailure = (error) =>
    ({ type: FETCH_MONITORING_DETAIL.FAILURE, payload: error });

// ==================== CREATE/UPDATE/DELETE ====================

export const createMonitoringRecordRequest = (recordData) =>
    ({ type: CREATE_MONITORING_RECORD.REQUEST, payload: recordData });

export const createMonitoringRecordSuccess = (record) =>
    ({ type: CREATE_MONITORING_RECORD.SUCCESS, payload: record });

export const createMonitoringRecordFailure = (error) =>
    ({ type: CREATE_MONITORING_RECORD.FAILURE, payload: error });

export const updateMonitoringRecordRequest = (recordId, recordData) =>
    ({ type: UPDATE_MONITORING_RECORD.REQUEST, payload: { recordId, recordData } });

export const updateMonitoringRecordSuccess = (record) =>
    ({ type: UPDATE_MONITORING_RECORD.SUCCESS, payload: record });

export const updateMonitoringRecordFailure = (error) =>
    ({ type: UPDATE_MONITORING_RECORD.FAILURE, payload: error });

export const deleteMonitoringRecordRequest = (recordId) =>
    ({ type: DELETE_MONITORING_RECORD.REQUEST, payload: { recordId } });

export const deleteMonitoringRecordSuccess = (recordId) =>
    ({ type: DELETE_MONITORING_RECORD.SUCCESS, payload: { recordId } });

export const deleteMonitoringRecordFailure = (error) =>
    ({ type: DELETE_MONITORING_RECORD.FAILURE, payload: error });

// ==================== UI STATE ====================

export const clearMonitoringRecords = () =>
    ({ type: CLEAR_MONITORING_RECORDS });

export const setSelectedMonitoringRecord = (record) =>
    ({ type: SET_SELECTED_MONITORING_RECORD, payload: record });
